export default "__VITE_ASSET__Dtx6J8sd__"